enum KpiOpenedRoutesAPI {
  KPIOPENED_LIST = '/customer-portal-service/KpiOpened',
  KPIOPENED_OS_TOTAL = '/customer-portal-service/KpiOpened/Total',

}

enum KpiOpenedRoutesApplication {
  OS_OPENED_GRAPHICS = '/application/osopenedgraphics'
}

export {
  KpiOpenedRoutesAPI,
  KpiOpenedRoutesApplication,
};
